import { render } from "./ContainerDetail.vue?vue&type=template&id=80e7de12&scoped=true"
import script from "./ContainerDetail.vue?vue&type=script&lang=js"
export * from "./ContainerDetail.vue?vue&type=script&lang=js"

import "./ContainerDetail.vue?vue&type=style&index=0&id=80e7de12&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e7de12"]])

export default __exports__